import { QueryKey, UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

const FEATURE_QUERY_STALE_TIME = 30_000;

export interface FeatureQueryOptions<TData>
  extends Omit<UseQueryOptions<TData, unknown, TData, QueryKey>, 'queryKey' | 'queryFn'> {
  queryKey: QueryKey;
  queryFn: (signal: AbortSignal | undefined) => Promise<TData>;
}

export function useFeatureQuery<TData>(options: FeatureQueryOptions<TData>): UseQueryResult<TData> {
  const { queryKey, queryFn, staleTime = FEATURE_QUERY_STALE_TIME, ...rest } = options;

  return useQuery<TData, unknown, TData, QueryKey>({
    queryKey,
    queryFn: ({ signal }) => queryFn(signal),
    staleTime,
    ...rest,
  });
}
